<template>
    <div class="relative flex self-start justify-start mt-7 lg:mt-6 w-auto">
        <dropdown
            v-if="isPolishLangVersion"
            :toggler-class="drodpownTogglerClass"
            content-class="w-full px-3 py-6 bg-black border-2 px-10 border-orange high-contrast:border-yellow-300"
            @open="isDropdownOpen = true"
            @close="isDropdownOpen = false"
        >
            <template slot="toggler">
                <span class="text-center px-2 uppercase md:px-4">{{ __('Muzyka') }}</span>
            </template>
            <template slot="content">
                <ul class="mb-6 text-lg leading-9 sm:text-1375xl text-white high-contrast:text-yellow-300">
                    <li>
                        <a class="uppercase" :href="route('front.product.index') + '?filters[availabilities]=preorder#products-list'">
                            {{ __('Preorder') }}
                        </a>
                    </li>
                    <li>
                        <a class="uppercase" :href="route('front.product.index') + '?options[limit]=' + productsLimit + '#products-list'">
                            {{ __('Nowości') }}
                        </a>
                    </li>
                    <li>
                        <a class="uppercase" :href="route('front.product.index') + '?filters[promotions]=true#products-list'">
                            {{ __('Promocje') }}
                        </a>
                    </li>
                    <li
                        v-for="(category, index) in categories"
                        :key="`navbar-product-categories-${index}`"
                    >
                        <a :href="route('front.product.index') + '?filters[categories]=' + category.id + '#products-list'" class="uppercase">
                            {{ category.name }}
                        </a>
                    </li>
                </ul>
                <a :href="route('front.product.index') + '#products-list'" type="button" class="block px-4 py-2 text-lg text-center text-white border-2 border-white rounded-none appearance-none hover:bg-white hover:text-orange sm:px-6 sm:text-1375xl high-contrast:border-yellow-300 high-contrast:text-yellow-300 high-contrast:hover:bg-yellow-300 high-contrast:hover:text-black">
                    {{ __('Pokaż wszystko') }}
                </a>
            </template>
        </dropdown>

        <a :href="route('front.event.index')" type="button" class="text-center flex items-center px-3 !leading-none font-normal text-white uppercase rounded-none appearance-none text-base xl:px-6 lg:text-xl bg-orange high-contrast:bg-yellow-300 high-contrast:text-black" :class="isPolishLangVersion ? 'ml-2' : 'py-2'">
            {{ __('Bilety') }}
        </a>

        <a :href="route('front.gift_card.index')" type="button" class="text-center flex items-center px-3 !leading-none font-normal text-white uppercase rounded-none appearance-none text-base xl:px-6 lg:text-xl bg-orange high-contrast:bg-yellow-300 high-contrast:text-black ml-2">
            {{ __('Karty upominkowe') }}
        </a>

    </div>
</template>

<script>
import Dropdown from "@/front/components/Dropdown";

const DEFAULT_LIMIT_OF_NEW_PRODUCTS = 48;

export default {
    props: {
        categories: {
            type: Array,
            required: false,
            default: () => []
        }
    },
    components: {
        Dropdown
    },
    data() {
        return {
            isDropdownOpen: false,
            productsLimit: DEFAULT_LIMIT_OF_NEW_PRODUCTS,
            isPolishLangVersion: window.Laravel.locale == 'pl'
        }
    },
    computed: {
        drodpownTogglerClass() {
            return [
                "border-2 border-orange py-2 px-3 xl:px-10 text-white text-base lg:text-xl high-contrast:border-yellow-300",
                this.isDropdownOpen ? "bg-black high-contrast:text-yellow-300" : "bg-orange high-contrast:bg-yellow-300 high-contrast:text-black"
            ];
        }
    }
};
</script>
